module.exports = __webpack_public_path__ + "static/media/tafe.250c2620.png";